// extracted by mini-css-extract-plugin
export var wordContainer = "_po-0";